/**
 * @generated SignedSource<<07eea4c1412712752202e50178009705>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraDashboard_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraDashboard";
  readonly description: string;
  readonly iconUrl: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraDashboard_AtlassianSearchPage";
};
export type searchJiraDashboard_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraDashboard_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraDashboard_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchJiraDashboard_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    }
  ],
  "type": "SearchResultJiraDashboard"
};

(node as any).hash = "165d504f5f9abf8bec64d659ff7dcd0c";

export default node;
